import { NotificationType } from "../../enums/NotificationType"

type Props = {
    type: NotificationType;
}

export const NotificationIcon = ({ type }: Props) => {
    switch (type) {
        case NotificationType.INFO:
            return <i className="bi bi-info-circle-fill info"></i>
        case NotificationType.SUCCESS:
            return <i className="bi bi-check-circle-fill success"></i>
        case NotificationType.WARNING:
            return <i className="bi bi-exclamation-triangle-fill warning"></i>
        case NotificationType.ERROR:
            return <i className="bi bi-x-circle-fill error"></i>
        default:
            return <></>
    }
}